var map = {
	"./amount.js": "VWFl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6GBZ";


//////////////////
// WEBPACK FOOTER
// ./src/filter/modules nonrecursive ([A-Z]|\w+)\.(js)$
// module id = 6GBZ
// module chunks = 8